import { ClipImage, SectionHead } from "./Reveal";

const PHOTOS = [
  ["/img/slus1.jpg", "Soggiorno con parquet a spina francese e parete attrezzata con luce LED", "md:col-span-8 aspect-[16/10]"],
  ["/img/slus2.jpg", "Bagno con vasca freestanding, lastra effetto marmo nero e rubinetteria oro", "md:col-span-4 aspect-[4/5] md:aspect-auto"],
  ["/img/slus3.jpg", "Veranda con pavimento in resina e serramenti scorrevoli", "md:col-span-4 aspect-[4/5]"],
  ["/img/slus4.jpg", "Parquet in rovere e libreria in cartongesso", "md:col-span-4 aspect-[4/5]"],
  ["/img/slus5.jpg", "Posa del pavimento in legno e binari luce", "md:col-span-4 aspect-[4/5]"],
  ["/img/slus6.jpg", "Scala con gradini retroilluminati e pavimento effetto marmo", "md:col-span-4 aspect-[4/5] md:aspect-auto"],
  ["/img/slus7.jpg", "Salone con boiserie, nuovi serramenti e parquet a spina", "md:col-span-8 aspect-[16/10]"],
  ["/img/slus8.jpg", "Camera con boiserie, cornici in gesso e luce LED a soffitto", "md:col-span-4 aspect-[4/5]"],
  ["/img/slus9.jpg", "Cucina su misura con top e paraschizzi effetto pietra", "md:col-span-4 aspect-[4/5]"],
  ["/img/slus10.jpg", "Soggiorno con soffitti alti, boiserie e parquet a spina", "md:col-span-4 aspect-[4/5]"],
];

export const Gallery = () => (
  <section id="galleria" data-testid="gallery-section" className="relative bg-[#ece5d8] py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <SectionHead light label="Galleria" title={<>Il nostro <em className="italic text-[#7d5a12]">lavoro.</em></>} />
        <p className="max-w-sm text-[#4a443a] leading-relaxed">
          Foto dimostrative delle lavorazioni che eseguiamo a Roma e dintorni.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
        {PHOTOS.map(([src, alt, cls], i) => (
          <figure key={src} className={`relative overflow-hidden ${cls}`}>
            <ClipImage src={src} alt={alt} testid={`gallery-image-${i}`} className="absolute inset-0" />
            <figcaption data-testid={`gallery-caption-${i}`} className="absolute inset-x-0 bottom-0 pt-16 pb-5 px-5 md:px-6 bg-gradient-to-t from-[#0d0d0e]/85 via-[#0d0d0e]/40 to-transparent pointer-events-none">
              <span className="block text-[11px] tracking-[0.3em] uppercase text-[#e8c063]">{String(i + 1).padStart(2, "0")}</span>
              <span className="mt-1 block font-display text-lg md:text-xl leading-snug text-[#f4f1ea]">{alt}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
